<template>
  <div id="top" class="page">
    <SiteHeader />
    <main>
      <HeroSection />
      <AboutSection />
      <ServiceSection />
      <AiDevelopmentSection />
      <WorksSection />
      <MessageSection />
      <PublicationsSection />
      <ContactSection />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import HeroSection from './components/HeroSection.vue'
import AboutSection from './components/AboutSection.vue'
import ServiceSection from './components/ServiceSection.vue'
import AiDevelopmentSection from './components/AiDevelopmentSection.vue'
import WorksSection from './components/WorksSection.vue'
import MessageSection from './components/MessageSection.vue'
import PublicationsSection from './components/PublicationsSection.vue'
import ContactSection from './components/ContactSection.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    HeroSection,
    AboutSection,
    ServiceSection,
    AiDevelopmentSection,
    WorksSection,
    MessageSection,
    PublicationsSection,
    ContactSection,
    SiteFooter,
  },
}
</script>

<style>
#app {
  margin: 0;
}

#top {
  scroll-margin-top: 0;
}
</style>
